
export enum CheshireRecordType  {           
    Monument = "mon",     
    Event = "event", 
    Source = "source",
    Designation = "desig",
    HLC = "hlc",
    AreaBoundary = "bound"
}  

export enum CheshireRecordSubType  {   
    AreaArchaeologicalImportance = "AAI",
    AreaArchaeologicalPotential = "AAP",
    AreaSpecialArchaeologicalPotential = "ASP",
    ConservationArea = "COA",
    ListedBuilding = "LB",
    LocallyListedBuilding = "LLB",
    RegisteredParksAndGardens = "RG",
    RegisteredBattlefields = "RB",
    ScheduledMonument = "SAM",
    SHINE = "SHINE",
    WorldHeritageSite = "WHS",
    UADCharacterZones="CHZ"
}  

